import { DEFAULT_LANG, DEFAULT_CURRENCY_ISO } from '@rover/shared/js/constants/i18n/language';

export const getIntlNumberFormat = (currencyIso = DEFAULT_CURRENCY_ISO, locale = DEFAULT_LANG) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyIso,
  });

export const formatCurrency = (
  amount,
  currencyIso = DEFAULT_CURRENCY_ISO,
  locale = DEFAULT_LANG,
  { includeDecimal = true, formatSymbol, formatAmount } = {}
) => {
  const parts = getIntlNumberFormat(currencyIso, locale).formatToParts(amount);
  let formattedCurrency = '';
  let formattedAmount = '';
  let currencyIndex = 0;
  parts.forEach((part, index) => {
    const { type, value } = part;
    if (type === 'currency') {
      currencyIndex = index;
      formattedCurrency = value;
    } else if (includeDecimal || !['decimal', 'fraction'].includes(type)) {
      formattedAmount += value;
    }
  });
  if (typeof formatSymbol === 'function') {
    formattedCurrency = formatSymbol(formattedCurrency);
  }
  if (typeof formatAmount === 'function') {
    formattedAmount = formatAmount(formattedAmount);
  }
  if (currencyIndex > 0) {
    return formattedAmount + formattedCurrency;
  }
  return formattedCurrency + formattedAmount;
};

export const formatCurrencyFromPriceObj = (priceObj, locale) =>
  formatCurrency(priceObj.amount, priceObj.currency_iso, locale);

export const getCurrencyAndLocaleConfig = (currencyIso, locale = DEFAULT_LANG) => {
  const formatter = getIntlNumberFormat(currencyIso, locale);

  const config = {};
  formatter.formatToParts(1000.0).forEach(({ type, value }, index) => {
    if (type === 'currency') {
      config.symbol = value;
      config.symbolOnLeft = index === 0;
    }
    if (type === 'group') {
      config.thousandsSeparator = value;
    }
    if (type === 'decimal') {
      config.decimalSeparator = value;
    }
    if (type === 'fraction') {
      config.decimalDigits = value.length;
    }
  });

  return {
    currencyConfig: {
      symbol: config.symbol,
      decimalDigits: config.decimalDigits,
    },
    localeConfig: {
      locale,
      symbolOnLeft: config.symbolOnLeft,
      thousandsSeparator: config.thousandsSeparator,
      decimalSeparator: config.decimalSeparator,
    },
  };
};



// WEBPACK FOOTER //
// ../utilities/currency.js